const state = {
  offersList: [],
  isHasMoreOffers: true,
  isHasMoreLenderOffers: true,
  lenderOffersCount: 0,
  archivedOffersList: [],
  archivedOffersCount: 0
};

const actions = {
  async getOffersList(context, params) {
    const list = await window.$httpService.offers.getOffersList(params);
    context.commit('setOffersList', list.data?.rows);

    if(list.data?.rows.length < 10) {
      context.commit('setHasMoreOffers', false);
    } else {
      context.commit('setHasMoreOffers', true);
    }
  },
  async updateOffersList(context, params) {
    const list = await window.$httpService.offers.updateOffersList(params);
    context.commit('updateOffersList', list.data?.rows);
    
    if(list.data?.rows.length < 10) {
      context.commit('setHasMoreOffers', false);
    } else {
      context.commit('setHasMoreOffers', true);
    }
  },
  async changeOfferStatus(context, data) {
    await window.$httpService.offers.changeOfferStatus(data);
  },
  async deleteOffer(context, offerPublicId) {
    await window.$httpService.offers.deleteOffer(offerPublicId);
  },
  async getLenderOffersList(context, params) {
    const list = await window.$httpService.offers.getLenderOffersList(params);
    context.commit('setOffersList', list.data?.rows);
    context.commit('setLenderOffersCount', list.data?.count);

    if(list.data?.rows.length < params?.size) {
      context.commit('setHasMoreLenderOffers', false);
    } else {
      context.commit('setHasMoreLenderOffers', true);
    }
  },
  async getOffersArchivedList(context, params) {
    const list = await window.$httpService.offers.getOffersArchivedList(params);
    context.commit('setArchivedOffersList', list.data?.rows);
    context.commit('setArchivedOffersCount', list.data?.count);
  },
};

const mutations = {
  setOffersList(state, data) {
    state.offersList = data;
  },
  setHasMoreOffers(state, data) {
    state.isHasMoreOffers = data;
  },
  setHasMoreLenderOffers(state, data) {
    state.isHasMoreLenderOffers = data;
  },
  setLenderOffersCount(state, data) {
    state.lenderOffersCount = data;
  },
  updateOffersList(state, data) {
    state.offersList = data;
  },
  setArchivedOffersList(state, data) {
    state.archivedOffersList = data || [];
  },
  setArchivedOffersCount(state, data) {
    state.archivedOffersCount = data;
  }
};

const getters = {
  offersList(state) {
    return state.offersList;
  },
  isHasMoreOffers(state) {
    return state.isHasMoreOffers;
  },
  isHasMoreLenderOffers(state) {
    return state.isHasMoreLenderOffers;
  },
  lenderOffersCount(state) {
    return state.lenderOffersCount;
  },
  archivedOffersList(state) {
    return state.archivedOffersList;
  },
  archivedOffersCount(state) {
    return state.archivedOffersCount;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}